module.exports = __webpack_public_path__ + "static/img/1.107c92c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3/1.png
// module id = IYLa
// module chunks = 1